
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { StoreBootstrapProvider, type StoreBootstrap } from './contexts/StoreBootstrap';
import { SeoHeadContext } from './contexts/SeoHead';
import './index.css';
import './redesign.css';

const chunkReloadKey = `chunk-reload:${window.location.pathname}`;
window.addEventListener('vite:preloadError', (event) => {
  // Don't preventDefault(): letting the original error keep propagating (instead of
  // resolving the import to `undefined`) lets the route ErrorBoundary recognize this
  // as a recoverable stale-chunk error and show a neutral loader instead of a crash screen.
  if (sessionStorage.getItem(chunkReloadKey)) return;
  sessionStorage.setItem(chunkReloadKey, '1');
  window.location.reload();
});
window.setTimeout(() => sessionStorage.removeItem(chunkReloadKey), 30_000);

let rootElement = document.getElementById('root');
if (!rootElement) {
  // If the root element is missing (serving the wrong HTML or file),
  // create a fallback so the app doesn't crash immediately.
  rootElement = document.createElement('div');
  rootElement.id = 'root';
  document.body.appendChild(rootElement);
  // eslint-disable-next-line no-console
  console.warn('No #root element found — created fallback #root and mounted the app.');
}

const snapshot = document.getElementById('__FELGOCAR_SSR__');
let bootstrap: StoreBootstrap | null = null;
try {
  const candidate: StoreBootstrap | null = snapshot ? JSON.parse(snapshot.textContent || 'null') : null;
  if (candidate?.version === 1 && candidate.buildId === __FELGOCAR_BUILD_ID__ && rootElement.dataset.rendered === 'react') bootstrap = candidate;
} catch { /* An incomplete release falls back to the regular client application. */ }
const app = <React.StrictMode><SeoHeadContext.Provider value={null}><StoreBootstrapProvider value={bootstrap}><App /></StoreBootstrapProvider></SeoHeadContext.Provider></React.StrictMode>;
if (bootstrap && bootstrap.buildId === __FELGOCAR_BUILD_ID__ && rootElement.dataset.rendered === 'react') {
  ReactDOM.hydrateRoot(rootElement, app, {
    onRecoverableError(error) {
      window.dispatchEvent(new CustomEvent('felgocar:hydration-error', { detail: String(error) }));
      console.error('Hydration error:', error);
    },
  });
} else {
  ReactDOM.createRoot(rootElement).render(app);
}
